<template lang="html">
<section class="aChat">
    <div v-if="true">
        <div class="left"><b>Customer</b></div>
        <div class="right"><b>Agent/Bot</b></div>
        <br />
        <basic-vue-chat class="Vlt-margin--top0 Vlt-margin--bottom1" :title="''" :new-message="message" @newOwnMessage="onNewOwnMessage" />

        <div class="sel">Send Response Via <select class="sel" name="typeSelect" id="typeSelect" v-model="selected">
                <option v-for="wf in wfs" :value="wf.wf">{{ wf.description}}</option>
            </select>
        </div>
        <vlt-button v-if="false" label="SMS Message" @click="addMessage('customer','sms','bot','Customer message blah blah')" />
    </div>
    <div v-else>
        <beautiful-chat :participants="participants" :agentProfile="agentProfile" :onMessageWasSent="onMessageWasSent" :messageList="messageList" :newMessagesCount="newMessagesCount" :isOpen="isChatOpen" :close="closeChat" :open="openChat" :showEmoji="true" :showFile="true" />
    </div>
    <!--
    <vlt-button label="My Message" @click="addMessage(0,'MY message!!')" />
    <vlt-button label="WhatsApp Message" @click="addMessage(2,'Agent message')" />
    -->
</section>
</template>

<script lang="js">
import {
    VltIcon,
    VltButton,
    VltCard,
    VltTab,
    VltGrid,
    VltCol,
    VltField,
    VltInput,
    VltCallout,
} from "@vonagevolta/vue";
import {
    FontAwesomeIcon
} from '@fortawesome/vue-fontawesome';
import {
    $HTTPDEMO,
    requestHandler
} from '../../services/nidsService.js';

import BasicVueChat from "basic-vue-chat";
import axios from 'axios';
export default {
    name: 'aChat',
    props: {
        nexmo: {
            type: Object,
            required: false
        },
        nodeurl: {
            type: String,
            required: true
        }
    },
    components: {
        "vlt-icon": VltIcon,
        "vlt-button": VltButton,
        "vlt-field": VltField,
        "vlt-input": VltInput,
        "vlt-callout": VltCallout,
        "basic-vue-chat": BasicVueChat,
        //        "font-awesome-icon": FontAwesomeIcon,
    },
    data() {
        return {
            message: {},
            NODEDEMO: {},
            selected: '0',
            pusher: {},
            wfs: [{
                    wf: "0",
                    description: "SMS"
                },
                {
                    wf: "1",
                    description: "WhatsApp"
                },
                /*                {
                                    wf: "2",
                                    description: "Voice"
                                },
                                {
                                    wf: "3",
                                    description: "MMS"
                                },
                */
            ],
            HTTP: null,
            agentProfile: {
                teamName: 'Vue Beautiful Chat',
                imageUrl: 'https://a.slack-edge.com/66f9/img/avatars-teams/ava_0001-34.png'
            },
            messageList: [],
            newMessagesCount: 0,
            isChatOpen: true,
            participants: [{
                    id: 'mattmezza',
                    name: 'Matteo',
                    imageUrl: 'https://avatars3.githubusercontent.com/u/1915989?s=230&v=4'
                },
                {
                    id: 'support',
                    name: 'Support',
                    imageUrl: 'https://avatars3.githubusercontent.com/u/37018832?s=200&v=4'
                }
            ],
        }
    },
    methods: {
        addMessage(entity, dst_entity, channel, txt) {
            entity = entity.toLowerCase();
            channel = channel.toLowerCase();
            var id = 1;
            var author = "";
            if (entity == 'agent' || entity == 'bot') {
                id = 0;
                if (entity == 'bot') {
                    author = "Bot";
                    txt = "(DialogFlow): " + txt;
                } else {
                    txt = "(" + channel + "): " + txt;
                }
            } else {
                if (channel == "voice") {
                    author = "Voice";
                    //                    this.selected = 2;
                } else if (channel == "whatsapp") {
                    author = "WhatsApp";
                    this.selected = 1;
                } else if (channel == "mms") {
                    author = "MMS";
                    this.selected = 3;
                } else {
                    author = "SMS";
                    this.selected = 0;
                }
            }
            var date = new Date().toLocaleTimeString([], {
                hourCycle: 'h24'
            });
            this.message = {
                id: id,
                author: author,
                contents: txt,
                date: date
            };
        },
        onNewOwnMessage(msg) {
            console.log("Sending type : " + this.selected + " with message: " + msg);
            var chan = "sms";
            if (this.selected == 2) {
                chan = "voice";
            } else if (this.selected == 1) {
                chan = "whatsapp";
            } else if (this.selected == 3) {
                chan = "mms";
            }
            this.NODEDEMO.post('/chatsend', {
                channel: chan,
                text: msg
            });
        },
        sendMessage(msg) {
            if (text.length > 0) {
                this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
                this.messageList.push(msg)
            }
        },
        onMessageWasSent(msg) {
            this.messageList.push(msg)
        },
        openChat() {
            this.isChatOpen = true
            this.newMessagesCount = 0
        },
        closeChat() {
            this.isChatOpen = false
        },
    },
    created() {

        //        this.HTTP = axios.create({
        //            baseURL:'https://c72efadd.ngrok.io/',
        //            headers: {
        //                'Content-Type': 'application/json'
        //            }
        //       });
        this.NODEDEMO = axios.create({
            baseURL: this.nodeurl,
            headers: {
                'Content-Type': 'application/json'
            }
        })

        this.NODEDEMO.interceptors.request.use(
            request => requestHandler(request)
        )
        let pusher = new Pusher(this.nexmo['pusher_key'], { //Pusher Key
            cluster: 'us3',
            forceTLS: true
        });
        this.pusher = pusher;
        this.channel = pusher.subscribe("sentiment");
        this.channel.bind("chat_" + this.nexmo.userid, data => {
            console.log("Got chat data: " + JSON.stringify(data));
            this.addMessage(data.src_entity, data.dst_entity, data.channel, data.text);
        });
    },
    beforeDestroy() {
        console.log("beforeDestroy for chat")
        if (this.pusher) {
            this.pusher.unsubscribe("sentiment");
        }
    },
}
</script>

<style lang="scss" scoped>
.left {
    float: left;
}

.right {
    float: right;
    padding-right: 5px;
}

.sel {
    padding: 5px;
    font-weight: bold;
}

//@import "@basic-vue-chat/assets/scss/modules/_all.scss";

$primary: red;
$secondary: blue;
$header-color: blue;
$window-height: 200px;
// above the following import you can override default values of variables like $primary
</style>
